<template>
  <div>
    <div class="home">
      <MenuTop />
      <div class="aa">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="item in slideshowList" :key="item">
            <div class="item_box">
              <div class="item">
                <!-- <p class="text">BUSINESS&nbsp;&nbsp;LOAN</p> -->
                <!-- <button>LOAN</button> -->
              </div>
              <img class="imgs" :src="item.carousel" alt />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
        <div class="hk-1">
          <div class="block">
            <el-slider
                v-model="loanAmount"
                :min="limitInfo.limitmin"
                :max="limitInfo.limitmax"
            ></el-slider>
          </div>
          <div class="ruler">
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm">
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
<!--              <div class="mm"></div>-->
            </div>
            <div class="cm"></div>
            <span class="left">{{limitInfo.limitmin}}₱</span>
            <span class="right">{{limitInfo.limitmax}}₱</span>
          </div>
        </div>
<!--      <div class="box-info">-->
<!--        <svg-->
<!--          t="1709455555700"-->
<!--          class="icon icon-notice"-->
<!--          viewBox="0 0 1024 1024"-->
<!--          version="1.1"-->
<!--          xmlns="http://www.w3.org/2000/svg"-->
<!--          p-id="8498"-->
<!--          width="32"-->
<!--          height="32"-->
<!--        >-->
<!--          <path-->
<!--            d="M643.072 97.28c-20.48-12.8-45.568-14.848-70.656-3.072l-322.56 188.928h-158.72c-36.864 0-67.072 30.208-67.072 67.072v340.48c0 36.864 30.208 67.072 67.072 67.072h158.72l325.12 190.464c9.216 4.608 19.456 6.656 29.696 6.656 13.312 0 26.624-3.584 37.888-11.264 20.48-12.8 32.768-35.328 32.768-59.392v-727.04c0-24.576-12.288-47.104-32.256-59.904zM225.28 689.664l-133.12 1.024-1.024-338.944H225.28v337.92z m381.44 197.632l-313.344-183.808V336.896l312.32-182.784 1.536 730.112-0.512 3.072z m389.12-377.344c0 18.944-15.36 34.304-34.304 34.304h-155.648a34.304 34.304 0 0 1 0-68.608h155.648c18.944 0 34.304 15.36 34.304 34.304z m-218.624-174.08c-10.24-15.872-6.144-36.864 9.216-47.104L921.6 198.656c15.872-10.752 36.864-6.144 47.104 9.216 10.24 15.872 6.144 36.864-9.216 47.104L824.32 345.088c-5.632 4.096-12.288 5.632-18.944 5.632-10.752 0.512-21.504-4.608-28.16-14.848z m182.272 428.544c15.872 10.24 19.968 31.744 9.216 47.104-6.656 9.728-17.408 15.36-28.672 15.36-6.656 0-13.312-2.048-18.944-5.632l-135.168-90.112c-15.872-10.24-19.968-31.744-9.216-47.104 10.24-15.872 31.744-19.968 47.104-9.216l135.68 89.6z"-->
<!--            p-id="8499"-->
<!--            fill="#a95159"-->
<!--          />-->
<!--        </svg>-->
<!--        <div class="notice">-->
<!--          <div class="notice__inner">-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">974*****699</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱2729065</span>!-->
<!--            </div>-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">090*****314</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱1853670</span>!-->
<!--            </div>-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">080*****220</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱169836</span>!-->
<!--            </div>-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">054****142</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱1867243</span>!-->
<!--            </div>-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">099*****850</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱2865021</span>!-->
<!--            </div>-->
<!--            <div class="notice__item" style="font-weight:700;font-size:20px">-->
<!--              <span style="color:#A46F06">091*****667</span> successful borrowing-->
<!--              <span style="color:#A46F06">₱6523902</span>!-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="apply">
<!--        <h1>-->
<!--          <p style="width:100%;font-size:40px">Apply For A Loan</p>-->
<!--        </h1>-->

        <div class="apply-1">
          <div>
            <small
              style="width:100%;font-size:25px;"
            >Minimum </small>
            <p style="font-size: 24px;">{{limitInfo.limitmin}}₱</p>
          </div>
          <div class="line"></div>
          <div>
            <small
              style="width:100%;font-size:25px;"
            >Maximum</small>
            <p style="font-size: 24px;">{{limitInfo.limitmax}}₱</p>
          </div>
        </div>
      </div>

      <div class="loan">
        <div class="loan-right">
          <div class="amount">
            <p class="loan-amount">
             <span style="border-bottom: 1px solid #fff">Please Enter Loan Amount</span> </p>
            <div class="num">
              <p class="loan-amount" style="font-size: 20px;" @click="open">{{loanAmount}} ₱</p>
            </div>
            <p class="loan-amount" style="font-size: 18px;">Loan Installment</p>

          </div>

          <div class="repayment">
            <div class="repayment-buts">
              <button class="r1" :class="{ 'selected': selectedMonth === 0 }" @click="month6()">
                <small>{{limitInfo.limitmonth[0]}} Months</small>
              </button>
              <button class="r2" :class="{ 'selected': selectedMonth === 1 }" @click="month12()">
                <span>{{limitInfo.limitmonth[1]}}&nbsp;Months</span>
              </button>
            </div>
              <div class="repayment-buts">
              <button class="r3" :class="{ 'selected': selectedMonth === 2 }" @click="month24()">
                <span>{{limitInfo.limitmonth[2]}}&nbsp;Months</span>
              </button>
              <button class="r4" :class="{ 'selected': selectedMonth === 3 }" @click="month36()">
                <span>{{limitInfo.limitmonth[3]}}&nbsp;Months</span>
              </button>
            </div>
            <p class="loan-amount" style="font-size: 18px; margin-top: 5px; ">Monthly Installment</p>
            <div class="repayment-info">
              <div class="repayment-info-box">
              <div>
                <p>{{amountToTheAccount}} ₱</p>
                <small>Amount Apply</small>
              </div>
              <div>
                <p>{{monthlyRepayment}} ₱</p>
                <small>Monthly Payment</small>
              </div>
              </div>
              <div class="repayment-info-box">
              <div>
                <p>{{monthlyInterest}} ₱</p>
                <small>Monthly Interest</small>
              </div>
              <div>
                <p>{{loanRepaymentPeriod}} Month</p>
                <small>Monthly Installment Period</small>
              </div>
              </div>
            </div>
          </div>

          <div class="Interest">
            <p style="border-bottom: 1px solid #a95159">Monthly Interest</p>
            <div class="Interest-info">
              <small
                style="border-bottom: 1px solid #a95159;"
              >{{this.monthlyRepayment}}₱(Principal Plus interest {{parseFloat(lx)*100}}% = {{ Math.ceil((this.monthlyInterest))}} ₱)</small>
            </div>
            <div class="hk-2">
              <div class="hkxy">
                <label class="container" style="font-size:15px; margin: 10px auto;">
                  Agree
                  <a class="aaa" href="#/UserServiceAgreement">(User Service Agreement</a>)(
                  <a class="aaa" href="#/PolicyConditions">Policy Conditions</a>)
                  <input type="checkbox" v-model="checked" />
                  <span class="checkmark" @click="gopo()"></span>
                </label>
              </div>
            </div>
          </div>
              <div
                @click="goToApplyForALoan"
                class="h-bu hk-buts"
                style="color:white;font-size:20px "
              >Apply Now!</div>
          </div>
        </div>
      </div>
      <div class="hbox"></div>
    </div>
</template>

<script>
import MenuTop from "@/components/MenuTop.vue";
import axios from "axios";
export default {
  components: {
    MenuTop
  },
  data() {
    return {
      // 轮播图数组
      slideshowList:[],

      selectedMonth: 0,
      checked: false,
      loanAmount: 0,
      monthlyRepayment: 0,
      amountToTheAccount: 0,
      monthlyInterest: 0,
      loanRepaymentPeriod: 0,
      lx: 0.5,
      limitInfo: {
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        remark: null,
        id: 1,
        limitmin: 150000,
        limitmax: 2000000,
        limitmemo: "wwww",
        limitcs: 11,
        limitmonth: [],
        limitcsmonth: 11,
        limitserveramount: 1,
        limitserverlx: 1,
        limityqamount: 1
      },
      bor: false
    };
  },
  created() {
    this.getLimitInfo();
    ////console.log(1111)
  },
  mounted() {
    this.getslideshow();
    if (
      sessionStorage.getItem("aggree0") &&
      sessionStorage.getItem("aggree3")
    ) {
      this.checked = true;
    }
  },
  watch: {
    loanAmount(newValue, oldValue) {
      this.chooesMonth();
    }
  },
  methods: {
    async getslideshow(){
      const res = await axios.get(`/picture/picture/all.do`);
      // console.log(res)
      if(res.data.code==200){
        this.slideshowList = res.data.data
        this.slideshowList.sort(function(a,b){
          return a.sort-b.sort
        })
        console.log(this.slideshowList)
      }
    },
    gopo() {},
    async getLimitInfo() {
      try {
        const a = await axios.get(
          `/borrowingSys/borrowing/borro/isBorrowing?uid=${+sessionStorage.getItem(
            "token"
          )}`
        );
        //  //////console.log(a);
        if (a.data.msg != "可以借款") {
          this.bor = true;
        } else {
          this.bor = false;
        }

        const b = await axios.get(`limit/limit/uplimit`);
        this.limitInfo = b.data.data;
        this.loanAmount = this.limitInfo.limitmin;
        this.lx = this.limitInfo.limitserverlx;
        sessionStorage.setItem("month", this.limitInfo.limitmonth[0]);
        this.month6();
      } catch (error) {}
    },

    goToApplyForALoan() {
      if (1) {
      }
      if (!this.checked) {
        this.$message.error(
          "Please read and agree to the customer use agreement"
        );
        return;
      }
      if (this.bor) {
        this.$message.error("You can't borrow money");
        return;
      }

      sessionStorage.setItem("LoanAmount", this.loanAmount);
      sessionStorage.setItem("Interest", this.monthlyRepayment);
      sessionStorage.setItem("LoanMonth", this.loanRepaymentPeriod);

      this.$router.push("/ApplyForALoan");
    },
    formatTooltip(val) {
      this.month6();
      return val / 100;
    },
    open() {
      this.$prompt(`Please Enter The Loan Amount`, {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        center: true

        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      })
        .then(({ value }) => {
          const regex = /^\d+$/;
          if (!regex.test(value)) {
            this.$message({
              type: "error",
              message: "Invalid input"
            });
            return;
          }
          if (Number(value) > this.limitInfo.limitmax) {
            this.loanAmount = this.limitInfo.limitmax;
            this.$message({
              type: "success",
              message: "confirm success max"
            });
          } else if (Number(value) < this.limitInfo.limitmin) {
            this.loanAmount = this.limitInfo.limitmin;
            this.$message({
              type: "success",
              message: "confirm success min"
            });
          } else {
            this.loanAmount = Number(value);
            this.$message({
              type: "success",
              message: "confirm success"
            });
          }
          this.chooesMonth();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancel"
          });
        });
    },
    chooesMonth() {
      if (sessionStorage.getItem("month") == "6") {
        this.month6();
      }
      if (sessionStorage.getItem("month") == "12") {
        this.month12();
      }
      if (sessionStorage.getItem("month") == "24") {
        this.month24();
      }
      if (sessionStorage.getItem("month") == "36") {
        this.month36();
      }
    },
    month6(index) {
      this.selectedMonth = 0;
      ////////console.log(index);
      this.amountToTheAccount = this.loanAmount;
      this.monthlyInterest = this.loanAmount * this.lx;
      this.monthlyRepayment =
        this.loanAmount / this.limitInfo.limitmonth[0] + this.monthlyInterest;
      this.loanRepaymentPeriod = this.limitInfo.limitmonth[0];
      this.monthlyRepayment = Math.ceil(this.monthlyRepayment);
      this.monthlyInterest = Math.ceil(this.monthlyInterest);
      sessionStorage.setItem("month", this.limitInfo.limitmonth[0]);
    },
    month12() {
      this.selectedMonth = 1;
      this.amountToTheAccount = this.loanAmount;
      this.monthlyInterest = this.loanAmount * this.lx;
      this.monthlyRepayment =
        this.loanAmount / this.limitInfo.limitmonth[1] + this.monthlyInterest;
      this.loanRepaymentPeriod = this.limitInfo.limitmonth[1];
      this.monthlyRepayment = Math.ceil(this.monthlyRepayment);
      this.monthlyInterest = Math.ceil(this.monthlyInterest);
      sessionStorage.setItem("month", this.limitInfo.limitmonth[1]);
    },
    month24() {
      this.selectedMonth = 2;
      this.amountToTheAccount = this.loanAmount;
      this.monthlyInterest = this.loanAmount * this.lx;
      this.monthlyRepayment =
        this.loanAmount / this.limitInfo.limitmonth[2] + this.monthlyInterest;
      this.loanRepaymentPeriod = this.limitInfo.limitmonth[2];
      this.monthlyRepayment = Math.ceil(this.monthlyRepayment);
      this.monthlyInterest = Math.ceil(this.monthlyInterest);
      sessionStorage.setItem("month", this.limitInfo.limitmonth[2]);
    },
    month36() {
      this.selectedMonth = 3;
      this.amountToTheAccount = this.loanAmount;
      this.monthlyInterest = this.loanAmount * this.lx;
      this.monthlyRepayment =
        this.loanAmount / this.limitInfo.limitmonth[3] + this.monthlyInterest;
      this.loanRepaymentPeriod = this.limitInfo.limitmonth[3];
      this.monthlyRepayment = Math.ceil(this.monthlyRepayment);
      this.monthlyInterest = Math.ceil(this.monthlyInterest);
      sessionStorage.setItem("month", this.limitInfo.limitmonth[3]);
    }
  }
};
</script>
<style scoped>
p{
  margin: 0;
}
.sa {
  width: 100%;
  height: auto;
  padding-bottom: 0px;
}
.ruler {
  position: relative;
  width: 100%;
  //height: 10px;
  margin-bottom: 15px;
  margin-top: -10px;
}
.ruler .left{
  position: absolute;
  left: -20px;
  bottom: -30px;
  font-size: 12px;
}
.ruler .right{
  position: absolute;
  right: -20px;
  bottom: -30px;
  font-size: 12px;

}
.ruler .cm,
.ruler .mm {
  position: absolute;
  border-left: 1px solid #555;
  height: 14px;
  width: 10%;
}
.ruler .cm:after {
  position: absolute;
  bottom: -15px;
  font: 11px/1 sans-serif;
}
.ruler .mm {
  height: 5px;
}
.ruler .mm:nth-of-type(5) {
  height: 10px;
}
.ruler .cm:nth-of-type(1) {
  left: 0%;
}
.ruler .cm:nth-of-type(1):after {
  content: "";
  margin-left: -20px;

  left: -5%;
}
.ruler .cm:nth-of-type(3) {
  left: 25%;
}
.ruler .cm:nth-of-type(3):after {
  content: "";
  left: -5%;
}
.ruler .cm:nth-of-type(4) {
  left: 50%;
}
.ruler .cm:nth-of-type(4):after {
  content: "";
  left: -5%;
}
.ruler .cm:nth-of-type(6):after {
  content: "";
  left: -5%;
}
.ruler .cm:nth-of-type(8) {
  left: 75%;
}
.ruler .cm:nth-of-type(8):after {
  content: "";
  left: -5%;
}

.ruler .cm:nth-of-type(11) {
  left: 100%;
}
.ruler .cm:nth-of-type(11):after {
  content: "";
  margin-left: -20px;
  left: -5%;
}
.ruler .mm:nth-of-type(1) {
  left: 10%;
}
.ruler .mm:nth-of-type(2) {
  left: 20%;
}
.ruler .mm:nth-of-type(3) {
  left: 30%;
}
.ruler .mm:nth-of-type(4) {
  left: 40%;
}
.ruler .mm:nth-of-type(5) {
  left: 50%;
}
.ruler .mm:nth-of-type(6) {
  left: 60%;
}
.ruler .mm:nth-of-type(7) {
  left: 70%;
}
.ruler .mm:nth-of-type(8) {
  left: 80%;
}
.ruler .mm:nth-of-type(9) {
  left: 90%;
}
.ruler .mm:nth-of-type(10) {
  left: 100%;
}
#mentionme {
  text-align: center;
  margin-top: 10%;
}

::v-deep .el-slider__button {
  height: 30px;
  width: 30px;
}
::v-deep .el-slider__bar {
  height: 15px;
  background-image: linear-gradient(90deg, #44dcf9 0%, #2ca1fa 100%);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  position: absolute;
}
::v-deep .el-slider__button-wrapper {
  height: 36px;
  width: 36px;
  z-index: 1001;
  top: -10px;
}
::v-deep .el-slider__runway {
  width: 100%;
  height: 15px;
  margin: 16px 0;
  background-color: #e4e7ed;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
}

.aaa {
  margin-top: 20px;
}
.hkxy {
  width: 100%;
  padding: 20px 0 3px;
  color: firebrick;
  a{
    color: firebrick;
  }
}
/* 容器 */
.container {
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 10px;
}

/* 隐藏浏览器的默认复选框 */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* 创建自定义复选框 */
.checkmark {
  position: absolute;
  top: -5px;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
}
.container a {
  padding: 30px 0;
}

/* 在鼠标悬停时，添加灰色背景色 */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* 当复选框被选中时，添加一个蓝色背景 */
.container input:checked ~ .checkmark {
  background-color: #2196f3;
}

/* 创建复选标记/指示器（未选中时隐藏）*/
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* 选中时显示复选标记 */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* 设置复选标记/指示器的样式 */
.container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.ppp {
  margin-top: 10px;
  padding: 10px 80px;
  font-size: 30px;
}
.english {
  width: 90%;
  display: flex;
  justify-content: right;
}
.customClass {
  width: 50px;
}
/*
.r1:hover {
  background-color: #214d9e;
  color: white;
}
.r2:hover {
  background-color: #214d9e;
  color: white;
}
.r3:hover {
  background-color: #214d9e;
  color: white;
}
.r4:hover {
  background-color: #214d9e;
  color: white;
}

.h-bu:hover {
  background-color: #214d9e;
  color: white;
} */
.hk-buts {
  line-height: 80px;
  background-color: #a95159;
  color: white;
}
.hk-1 {
  margin: 10px auto;
  width: 80%;
}
.hk-2 {
  width: 100%;
}
.hk {
  width: 100%;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
}
.Interest {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #a95159;
}
.Interest p{
  margin-left: 10px;
}
.Interest .Interest-info{
  margin-left: 10px;
}
.repayment {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}
.repayment-buts {
  width: 100%;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #a95159;

}
.repayment-buts:nth-child(1) {
  border-bottom: none;
}
.repayment-buts button {
  //width: 24%;
  white-space: nowrap;
  padding: 5px 10px;
  margin: 10px 50px;
}
.repayment-buts span {
  font-size: 16px;
}
.repayment-info {
  width: 100%;
  justify-content: center;
}
.repayment-info-box{
  background-color: #a95159;
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 2px;
  padding: 5px 0;
}
.repayment-info .repayment-info-box div {
  width: 50%;
  margin: 0 auto;
  color: white;
}
.repayment-info .repayment-info-box div small {
  font-size: 12px;
}
.repayment-info .repayment-info-box div p {
  font-size: 20px;
  color: white;
}
.repayment button {
  //width: 22%;
  border: none;
  border-radius: 10px;
  font-size: 20px;
}
.num {
  display: flex;
  width: 100%;
  height: auto;
}
.num button {
  border: none;
  width: 50px;
  height: auto;
  background-color: white;
}
button {
  cursor: pointer;
}
.num p {
  font-size: 30px;
}
.amount {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  border-bottom: 1px solid #a95159;
}
.amount::before{
  content: "";
  height: 43px;
  width: 48px;
  top: 20px;
  left: 40px;
  background: url("../../public/Quicker124.png");
  position: absolute;
}
.icon {
  width: 80%;
}
.icon1 {
  position: absolute;
  left: 15%;
}
.icon2 {
  position: absolute;
  left: 15%;
  top: 40%;
}
.icon3 {
  position: absolute;
  left: 15%;
  top: 80%;
}
.loan-right {
  width: 100%;

}
.loan-left {
  width: 5%;
  height: 100%;
  position: relative;
}
.loan-left-line {
  position: absolute;
  width: 10%;
  height: 100%;
  left: 50%;
  background-color: rgb(212, 224, 224);
}
.loan {
  display: flex;
  width: 100%;
  height: 600px;
}
p {
  word-wrap: break-word;
  word-break: break-all;
}
.line {
  background-color: #a95159;
  width: 2px;
  height: 60px;
}
.apply-1 {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: auto;
  position: relative;
  margin-top: 40px;
  border-top: 1px solid #a95159;
  border-bottom: 1px solid #a95159;
  padding: 10px 0 10px 0;
}
.apply {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: auto;
  padding: 10px 0 10px 0;
}
.home {
  width: 100%;
  position: relative;
}
.box-info {
  width: 100%;
  height: 100px;
}
.ab-4 {
  background-color: #a95159;
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
}
.ab-4-1 {
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.ab-4-2 {
  margin-top: 20px;
}
.ab-4-1-1 {
  width: 300px;
  padding: 5px;
  background-color: #a95159;
  display: flex;
  justify-content: space-around;
  color: white;
}

.ab-4-1-1 {
  width: 500px;
}

.ab-box {
  background-color: #f0f0f7;
  padding: 50px;
  display: flex;
  justify-content: space-around;
  margin-top: 50px;
}
.ab {
  width: 450px;
  height: 200px;
  background-color: #a95159;
  position: relative;
}
.ab img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.ab-text {
  position: absolute;
  width: 100%;
  top: 20%;
  color: white;
}
.new-1-1 {
  border: none;
  background-color: #808199;
  width: 250px;
  border-radius: 10px;
  margin-top: 10px;
}
.img {
  width: 250px;
  height: 200px;
}
.img img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}
.news {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.news-text {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.news-1 {
  width: 200px;
  height: auto;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
}

.item_box {
  width: 100%;
  height: auto;
  position: relative;
}
.item {
  position: absolute;
  width: 100%;
  top: 20%;
}
.item p {
  font-size: 60px;
  color: white;
}
.item button {
  font-size: 20px;
  color: white;
  border: none;
  background-color: #a95159;
  border-radius: 30px;
  padding: 10px 30px 10px 30px;
}
.imgs {
  width: 100%;
  height: 300px;
  object-fit: fill;
}

.box-info {
  position: relative;
  margin-top: -5%;
}
.notice {
  width: 100%;
  height: 40px;
  margin: 100px auto;
  overflow: hidden;
}
.icon-notice {
  position: absolute;
  width: 30px;
  height: 30px;
  left: 2%;
}
.notice__inner {
  animation: roll 36s linear infinite;
  margin-top: 0;
}
.notice__item {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
}
@media screen and (max-width: 500px) {
  .notice {
    height: 80px;
  }
  .notice__item {
    height: 80px;
  }
  .icon-notice {
    display: none;
  }
  .repayment-info div small {
    font-weight: 600;
    font-size: 15px;
  }
  .repayment-info div p {
    font-weight: 600;
    font-size: 15px;
    color: red;
  }
}
@media screen and (max-width: 380px) {
  .notice {
    height: 80px;
  }
  .notice__item {
    height: 80px;
  }
  .icon-notice {
    display: none;
  }
  .repayment-info div small {
    font-weight: 600;
    font-size: 12px;
  }
  .repayment-info div p {
    font-weight: 600;
    font-size: 12px;
    color: red;
  }
}
@media screen and (max-width: 230px) {
  .notice {
    height: 120px;
  }
  .notice__item {
    height: 120px;
  }
  .icon-notice {
    display: none;
  }
}
@keyframes roll {
  0% {
    margin-top: 0;
  }
  4% {
    margin-top: 0;
  }
  8% {
    margin-top: 0;
  }
  12% {
    margin-top: -40px;
  }
  16% {
    margin-top: -40px;
  }
  20% {
    margin-top: -80px;
  }
  24% {
    margin-top: -80px;
  }
  28% {
    margin-top: -120px;
  }
  32% {
    margin-top: -120px;
  }
  36% {
    margin-top: -160px;
  }
  40% {
    margin-top: -160px;
  }
  44% {
    margin-top: -200px;
  }
  48% {
    margin-top: -200px;
  }
  52% {
    margin-top: -240px;
  }
  56% {
    margin-top: -240px;
  }
  60% {
    margin-top: -200px;
  }
  64% {
    margin-top: -200px;
  }
  68% {
    margin-top: -160px;
  }
  72% {
    margin-top: -160px;
  }
  76% {
    margin-top: -120px;
  }
  80% {
    margin-top: -120px;
  }
  84% {
    margin-top: -80px;
  }
  88% {
    margin-top: -80px;
  }
  92% {
    margin-top: -40px;
  }
  96% {
    margin-top: -40px;
  }
  100% {
    margin-top: 0;
  }
}
.apply {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: auto;
  padding: 0 0 10px 0;
  margin-top: -5%;
}

.r1,
.r2,
.r3,
.r4 {
  /* 默认的灰色样式 */
  background-color: rgba(198, 202, 205, 0.747);
}

.selected {
  /* 选中时的蓝色样式 */
  background-color: #a95159;
  color: white;
}
/*后来加的类
*/
.loan-amount{
  border-radius: 8px;
  background-color: #a95159;
  color: white;
  padding: 5px 10px;
  border-bottom: 2px solid #fff! important;
  margin: 0 auto;
  font-size: 14px;
}
</style>
